<template>
  <div>
    <base-header
      type="gradient-success"
      class="pb-6 pb-8 pt-5 pt-md-8"
    ></base-header>
    <div class="container-fluid mt--7">
      <div class="row justify-content-center add__surah__form">
        <div class="col-lg-8 col-md-12">
          <span class="add__user_cross" @click="$router.go(-1)">&#10006;</span>
          <template>
            <form @submit.prevent>
              <h6 class="heading-small text-muted mb-4">Surah information</h6>
              <div class="pl-lg-4">
                <div class="row">
                  <div class="col-lg-6">
                    <label class="surah__form__label">Surah Number</label>
                    <base-input
                      alternative=""
                      placeholder="Surah Number"
                      input-classes="form-control-alternative"
                      v-model="model.surahNum"
                      type="number"
                      min="1"
                      max="114"
                      @keyup="onKeyUp($event, 'surahNum')"
                      class="mb-0"
                      :class="{ 'has-danger input-danger': surahNumErr }"
                    />
                    <span
                      v-show="surahNumErr"
                      class="text-danger"
                      v-text="surahNumMsg"
                    ></span>
                  </div>
                  <div class="col-lg-6">
                    <label class="surah__form__label">Para Number</label>
                    <base-input
                      alternative=""
                      placeholder="Para Number"
                      input-classes="form-control-alternative"
                      v-model="model.paraNum"
                      type="number"
                      min="1"
                      max="30"
                      @keyup="onKeyUp($event, 'paraNum')"
                      class="mb-0"
                      :class="{ 'has-danger input-danger': paraNumErr }"
                    />
                    <span
                      v-show="paraNumErr"
                      class="text-danger"
                      v-text="paraNumMsg"
                    ></span>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <!-- Address -->
              <h6 class="heading-small text-muted mb-4">
                Surah Name Translations
              </h6>
              <div class="pl-lg-4">
                <!-- <div class="row">
                                    <div v-for="(surahName, index) in model.surahNames" class="col-md-12 mb-3" :key="index">
                                        <label class="surah__form__label langNameLabel">{{surahName.langName}}</label>
                                        <base-input input-classes="form-control-alternative" v-if="surahName.langName != 'Arabština'"
                                                    :placeholder="'Enter '+surahName.langName+' Name'" 
                                                    v-model="model.surahNames[index].translation" @keyup="onKeyUpTranslationFields($event, index)"
                                                    :class="{'has-danger input-danger': model.surahNames[index].langNameErr}" />
                                        <base-input input-classes="form-control-alternative py-0 custom_input" v-if="surahName.langName == 'Arabština'"
                                                    :placeholder="'Enter '+surahName.langName+' Name'" class="dir__rtl"
                                                    v-model="model.surahNames[index].translation" @keyup="onKeyUpTranslationFields($event, index)"
                                                    :class="{'has-danger input-danger': model.surahNames[index].langNameErr}" />
                                        <span v-show="model.surahNames[index].langNameErr" class="text-danger" 
                                              v-text="model.surahNames[index].langNameMsg"></span>
                                    </div>
                                </div> -->
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label class="surah__form__label langNameLabel"
                      >Arabština</label
                    >
                    <textarea
                      class="form-control form-control-alternative custom_input dir__rtl"
                      name="arabicName"
                      :placeholder="'Enter Arabština Name'"
                      style="padding: 4px 10px"
                      lang="ar"
                      rows="1"
                      @keypress.enter.prevent
                      v-model="model.arabicName"
                      @input="model.arabicName = changeIntoArabic($event)"
                      :class="[
                        arabicNameErr && 'input-danger',
                        model.arabicName && $store.getters.arabicFontStyle,
                      ]"
                    />
                    <span
                      v-show="arabicNameErr"
                      class="text-danger"
                      v-text="arabicNameMsg"
                    ></span>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label class="surah__form__label langNameLabel"
                      >Čeština</label
                    >
                    <base-input
                      input-classes="form-control-alternative"
                      :placeholder="'Enter Čeština Name'"
                      v-model="model.czechName"
                      @keyup="onKeyUp($event, 'czechName')"
                      :class="{ 'has-danger input-danger': czechNameErr }"
                    />
                    <span
                      v-show="czechNameErr"
                      class="text-danger"
                      v-text="czechNameMsg"
                    ></span>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label class="surah__form__label langNameLabel"
                      >Čeština Transliteration</label
                    >
                    <base-input
                      input-classes="form-control-alternative"
                      :placeholder="'Enter Čeština transliteration Name'"
                      v-model="model.czechTrans"
                      @keyup="onKeyUp($event, 'czechTrans')"
                      :class="{ 'has-danger input-danger': czechTransErr }"
                    />
                    <span
                      v-show="czechTransErr"
                      class="text-danger"
                      v-text="czechTransMsg"
                    ></span>
                  </div>
                </div>
                <div class="text-center d-flex justify-content-between">
                  <base-button
                    type="default"
                    class="my-4"
                    @click.prevent="resetForm"
                    >Reset</base-button
                  >
                  <base-button
                    type="success"
                    class="my-4"
                    @click.prevent="addSurah"
                    >Add Surah</base-button
                  >
                </div>
              </div>
            </form>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/apiList";
export default {
  name: "addsurah",
  data: function () {
    return {
      languages: JSON.parse(localStorage.getItem("languages")),
      model: {
        surahNum: "",
        paraNum: "",
        // surahNames: [],
        arabicName: "",
        czechName: "",
        czechTrans: "",
      },
      surahNumErr: false,
      paraNumErr: false,
      arabicNameErr: false,
      czechNameErr: false,
      czechTransErr: false,
      surahNumMsg: "",
      paraNumMsg: "",
      arabicNameMsg: "",
      czechNameMsg: "",
      czechTransMsg: "",

      alertShow: false,
      alertType: "",
      alertMsg: "",

      successRes: false,
    };
  },
  methods: {
    async addSurah() {
      if (this.validateForm()) {
        const data = await api.insertSurah(this.model);
        if (!data.response) {
          this.$toast(data.data.message, {
            position: "top-right",
            timeout: 5000,
            type: "success",
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            icon: true,
            rtl: false,
          });
        } else {
          this.$toast(data.response.data.message, {
            position: "top-right",
            timeout: 5000,
            type: "error",
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            icon: true,
            rtl: false,
          });
        }
      }
    },
    validateForm() {
      let hasErr = false;
      let instance = this;
      let model_inst = this.model;
      Object.keys(this.model).forEach((elem) => {
        if (!model_inst[elem] && elem != "paraNum" && model_inst[elem].trim() == ' ') {
          instance[elem + "Err"] = true;
          this[elem + "Msg"] = "This field is required.";
          hasErr = true;
        }
      });
      // model_inst.surahNames.forEach(elem => {
      //     if(!elem.translation || elem.translation == '') {
      //         if (elem.langName == 'Arabština') {
      //             elem.langNameErr = true;
      //             elem.langNameMsg = elem.langName + ' name is must.';
      //             hasErr = true;
      //         }
      //         if (elem.langName == 'Čeština - Hrbek') {
      //             elem.langNameErr = true;
      //             elem.langNameMsg = elem.langName + ' name is must';
      //             hasErr = true;
      //         }
      //     }
      // })
      return !hasErr;
    },
    resetForm() {
      this.$confirm({
        title: "Confirmations!",
        message: `Are you sure you want to reset the form because this action is not reveratable`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm) => {
          if (confirm) {
            Object.keys(this.model).forEach((elem) => {
              this.model = {};
            });
          }
        },
      });
    },
    onKeyUp: function (event, inputName) {
      let { surahNum, paraNum } = this.model;
      if (inputName == "surahNum") {
        this.surahNumErr = false;
        if (surahNum < 0) {
          this.model.surahNum = 1;
        }
        if (surahNum > 114) {
          this.model.surahNum = 114;
        }
      }
      if (inputName == "paraNum") {
        this.paraNumErr = false;
        if (paraNum < 0) {
          this.model.paraNum = 1;
        }
        if (paraNum > 30) {
          this.model.paraNum = 30;
        }
      }
      if (inputName == "czechName") {
        this.czechNameErr = false;
      }
      if (inputName == "czechTrans") {
        this.czechTransErr = false;
      }
    },
    // onKeyUpTranslationFields: function(event, index){
    //     this.model.surahNames[index].langNameErr = false;
    // },

    changeIntoArabic(e) {
      if (e.target.name == "arabicName") {
        this.arabicNameErr = false;
      }
      let val = e.target.value;
      val = val.replace(/`/g, "ذ");
      val = val.replace(/0/g, "۰");
      val = val.replace(/1/g, "۱");
      val = val.replace(/2/g, "۲");
      val = val.replace(/3/g, "۳");
      val = val.replace(/4/g, "٤");
      val = val.replace(/5/g, "۵");
      val = val.replace(/6/g, "٦");
      val = val.replace(/7/g, "۷");
      val = val.replace(/8/g, "۸");
      val = val.replace(/9/g, "۹");
      val = val.replace(/0/g, "۰");
      val = val.replace(/q/g, "ض");
      val = val.replace(/w/g, "ص");
      val = val.replace(/e/g, "ث");
      val = val.replace(/r/g, "ق");
      val = val.replace(/t/g, "ف");
      val = val.replace(/y/g, "غ");
      val = val.replace(/u/g, "ع");
      val = val.replace(/i/g, "ه");
      val = val.replace(/o/g, "خ");
      val = val.replace(/p/g, "ح");
      val = val.replace(/\[/g, "ج");
      val = val.replace(/\]/g, "د");
      val = val.replace(/a/g, "ش");
      val = val.replace(/s/g, "س");
      val = val.replace(/d/g, "ي");
      val = val.replace(/f/g, "ب");
      val = val.replace(/g/g, "ل");
      val = val.replace(/h/g, "ا");
      val = val.replace(/j/g, "ت");
      val = val.replace(/k/g, "ن");
      val = val.replace(/l/g, "م");
      val = val.replace(/\;/g, "ك");
      val = val.replace(/\'/g, "ط");
      val = val.replace(/z/g, "ئ");
      val = val.replace(/x/g, "ء");
      val = val.replace(/c/g, "ؤ");
      val = val.replace(/v/g, "ر");
      val = val.replace(/b/g, "لا");
      val = val.replace(/n/g, "ى");
      val = val.replace(/m/g, "ة");
      val = val.replace(/\,/g, "و");
      val = val.replace(/\./g, "ز");
      val = val.replace(/\//g, "ظ");
      val = val.replace(/~/g, " ّ");
      val = val.replace(/Q/g, "َ");
      val = val.replace(/W/g, "ً");
      val = val.replace(/E/g, "ُ");
      val = val.replace(/R/g, "ٌ");
      val = val.replace(/T/g, "لإ");
      val = val.replace(/Y/g, "إ");
      val = val.replace(/U/g, "‘");
      val = val.replace(/I/g, "÷");
      val = val.replace(/O/g, "×");
      val = val.replace(/P/g, "؛");
      val = val.replace(/A/g, "ِ");
      val = val.replace(/S/g, "ٍ");
      val = val.replace(/G/g, "لأ");
      val = val.replace(/H/g, "أ");
      val = val.replace(/J/g, "ـ");
      val = val.replace(/K/g, "،");
      val = val.replace(/L/g, "/");
      val = val.replace(/Z/g, "~");
      val = val.replace(/X/g, "ْ");
      val = val.replace(/B/g, "لآ");
      val = val.replace(/N/g, "آ");
      val = val.replace(/M/g, "’");
      val = val.replace(/\?/g, "؟");
      e.target.value = val;
      return e.target.value;
    },
  },
  created() {
    // let arabicLangObj = null;
    // let czechHrbekLangObj = null;
    // this.languages.forEach(elem => {
    //     let language = {translation: '', translationId: elem._id, langName: elem.name}
    //     if(elem.name == 'Arabština'){
    //         arabicLangObj = language;
    //     }
    //     else if(elem.name == 'Čeština - Hrbek') {
    //         czechHrbekLangObj = language;
    //     }
    //     else{
    //         this.model.surahNames.push(language)
    //     }
    // })
    // this.model.surahNames.unshift(arabicLangObj);
    // this.model.surahNames.splice(1, 0, czechHrbekLangObj);
  },
  mounted() {},
};
</script>
<style scoped>
.add__user_cross {
  cursor: pointer;
  position: absolute;
  right: 0 !important;
  top: -12px;
  border: 1px solid #f7fafc;
  background-color: #f7fafc;
  padding: 10px 15px;
  z-index: 9;
  border-radius: 100px;
  color: purple;
}
span.text-danger {
  font-size: 12px !important;
}
.input-danger {
  border: 1px solid red !important;
  border-radius: 7px;
}
.add__surah__form form {
  background: #f7fafc;
  padding: 10px 20px;
  border-radius: 0.375rem;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}
.surah__form__label {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}
.surah__form__label.langNameLabel + div {
  margin-bottom: 0px;
}
</style>
